import { Component, inject, OnInit, Signal, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { InvoicingService, ISaleStatus } from '../../../core/services/invoicing.service';
import { StoresService } from '../../../core/services/stores.service';
import { UserService } from '../../../core/services/user.service';
import { DatePipe } from '@angular/common';
import { SalesStatusComponent } from '../sales-status/sales-status.component';
import { TranslatePipe } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LoaderComponent } from '../../../shared-with-client/loader/loader.component';
import { InvoicePreviewComponent } from '../invoice-preview/invoice-preview.component';
import { IconComponent } from '../../../shared-with-client/icon/icon.component';
import { Dialog } from '@angular/cdk/dialog';
import { SaleDetailDocumentsComponent } from "../sale-detail-documents/sale-detail-documents.component";
import { SaleDetailActionsComponent } from "../sale-detail-actions/sale-detail-actions.component";

@Component({
    selector: 'app-sale-details',
    imports: [SalesStatusComponent, TranslatePipe, DatePipe, LoaderComponent, InvoicePreviewComponent, IconComponent, SaleDetailDocumentsComponent, SaleDetailActionsComponent],
    templateUrl: './sale-details.component.html',
    styleUrl: './sale-details.component.scss',
})
export class SaleDetailsComponent implements OnInit {
    private bsModalRef = inject(BsModalRef);
    private modalService = inject(Dialog);
    private bsModalService = inject(BsModalService);

    public sale: any;

    private invoicingService = inject(InvoicingService);
    private storesService = inject(StoresService);
    private userService = inject(UserService);

    // private sideDrawerService = inject(SideDrawerService);
    private router = inject(Router);

    public currentStore: Signal<any> = toSignal(this.storesService.getActiveStore());
    public currentUser: Signal<any> = toSignal(this.userService.currentUser);

    public loadingSaleDetails = signal(true);
    readonly ISaleStatus = ISaleStatus;

    public isInvoicingActive = toSignal(this.storesService.isInvoicingActive());

    public seeInvoicePreview = signal(true);

    ngOnInit(): void {
        this.getSaleDetails(this.sale.id);
    }

    getSaleDetails(id: number) {
        this.loadingSaleDetails.set(true);
        return this.invoicingService.getSaleDetails(id, this.currentStore().id).subscribe({
            next: (res) => {
                this.sale = res;
                this.loadingSaleDetails.set(false);
            },
        });
    }

    saleUpdated() {
        this.getSaleDetails(this.sale.id);
        this.bsModalService.setDismissReason('updated');
        this.router.navigateByUrl(`${this.currentStore().slug}/dashboard/sales`);
    }

    destroyPreview() {
        this.seeInvoicePreview.set(false);
    }

    close() {
        this.bsModalRef.hide();
    }
}
